<template>
    <div style="width:100%;height:100%">
        <buttonlist ref="SetBtn" @help="help"></buttonlist>
        <el-card class="box-card">
            <el-row style="display: flex;background: white;">
                <el-button type="primary" size="mini" @click="download">{{$t('getapi[6506]')}}</el-button>
                <el-button type="primary" size="mini" @click="showitems">{{ $t('getapi[438]') }}</el-button>
                <el-button type="primary" size="mini" @click="remove">{{ $t('getapi[4411]') }}</el-button>
                
                <el-col :span="5" style="text-align: left">
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
                            style="margin-left: 10px"
                    >
                    <el-button slot="trigger" size="mini" type="primary">{{ $t('getapi[4410]') }}</el-button>
                    </el-upload>
                </el-col>
                <el-col :span="18" style="text-align: right">
                    <span style="padding:0 20px;">{{ $t('getapi[506]') }}</span>
                    <el-select filterable v-model="editPlan" :placeholder="$t('getapi[6085]')" size="mini" style="margin-righ:20px">
                        <el-option v-for="item in editPlanList" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="2" style="text-align: right">
                    <el-button type="primary" size="mini" @click="update">{{ $t('getapi[507]') }}</el-button>
                    <!--<el-button type="primary" size="mini">关闭</el-button>-->
                </el-col>
            </el-row>
        </el-card>
        <el-card class="box-card">
            <!-- <div slot="header" class="clearfix"><span>计划相关设置</span></div> -->
            <vxe-table
                    :data="dataSet"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    resizable
                    :height="tableHeight"
                    header-row-class-name="headerclass"
                    tab-click="selectInfo(0)"
                    @checkbox-change="handleSelectionChange"
                    style="width: 100%; margin-top:0px"
                    ref="CloseSoTable"
            >
                <vxe-table-column type="checkbox" width="80" align="center"></vxe-table-column>
                <!-- <vxe-table-column show-overflow-tooltip field="exclusively_id" title="ID" v-if="false"></vxe-table-column> -->
                <vxe-table-column show-overflow-tooltip field="errmsg" :title="$t('getapi[715]')" width="300"></vxe-table-column>
                <vxe-table-column show-overflow-tooltip field="status" :title="$t('getapi[552]')" width="100"></vxe-table-column>                
                <vxe-table-column show-overflow-tooltip field="sale_part_code" :title="$t('getapi[2652]')" width="130"></vxe-table-column>
                <vxe-table-column show-overflow-tooltip field="sale_part_version" :title="$t('getapi[3939]')" width="80"></vxe-table-column>
                <vxe-table-column show-overflow-tooltip field="after_flag" :title="$t('getapi[13432]')" width="80"></vxe-table-column>
                <vxe-table-column show-overflow-tooltip field="cust_version" :title="$t('getapi[6352]')" width="80"></vxe-table-column>
                <vxe-table-column show-overflow-tooltip field="customer_code" :title="$t('getapi[2610]')" width="100"></vxe-table-column>
                <vxe-table-column show-overflow-tooltip field="customer_part_code" :title="$t('getapi[3034]')" width="80"></vxe-table-column>
                <vxe-table-column show-overflow-tooltip field="valid_flag" :title="$t('getapi[3035]')" width="80"></vxe-table-column>
                <vxe-table-column show-overflow-tooltip field="sale_part_version" :title="$t('getapi[3939]')" width="80"></vxe-table-column>                
                <vxe-table-column :class-name="editPlan == 'isfreeze' ? 'check' : ''"
                                 field="isfreeze" :title="$t('getapi[555]')" width="80">
                    <template scope="scope">
                        <el-select filterable class-name="check" v-model="scope.row.isfreeze"
                                   v-if="editPlan == 'isfreeze'">
                            <el-option v-for="item in isfreezeflag" 
                                :key="item.value" :title="item.title" :value="item.value" size="mini"></el-option>
                        </el-select>
                        <span v-if="editPlan != 'isfreeze'">{{ scope.row.isfreeze }}</span>
                    </template>
                </vxe-table-column>                
            </vxe-table>
        </el-card>
        <!--<pickpart :isVisible="itevisible" @getitembom="getitembom" ref="input"></pickpart>-->
        <selector :isVisible="itevisible" :isBatch=true :selectType="0" :isSplitPage=true
                  :postUrl="'/Sal/Price/GetSalPriceFreezePopupList'" @callback="getitembom" ref="input"></selector>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: 'salepricetsetting',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-180
            }
        },
        data() {
            return {
                itevisible: false,
                dataSet: [],
                dataChecked: [], // 选中的ID集合
                loading: false, // 主表加载状态
                uploadurl: '',
                fileList: [],
                editPlan: '0',
                editPlanList: [
                    {
                        value: '0',
                        label: this.$t('getapi[852]')//'未选择'
                    },
                    {
                        value: 'isfreeze',
                        label: this.$t('getapi[555]')//'是否冻结'
                    },
                    
                ],
                scrollTop:0,
                isfreezeflag: [
                    {
                        value: '否',
                        label: this.$t('getapi[2053]')//'否'
                    },
                    {
                        value: '是',
                        label: this.$t('getapi[2052]')//'是'
                    }
                ],
            };
        },
        beforeMount() {
            let that = this;
            that.fileList = [];
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Sal/Price/SalPriceFreezeImportUpFile?token=' + token;
        },
        mounted: function () {
            let that = this;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12905]"),this.$t("getapi[14]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                // //只读权
                that.$refs.SetBtn.SetButtonEnable('');
            },
            download(){
                let param={
                    url:'/Sal/Price/SalPriceFreezeTemplate'
                }
                Array.methods.DownLoadTemp(param);
            },
            // 新物料打开
            showitems() {
                this.itevisible = true;
                this.$refs.input.clearInput(this.itevisible);
            },
            getitembom(data) {
                let that = this
				console.log(data)
				that.iscontinue = 0
                let arr = data.filter(item => {
                    return  that.dataSet.every(item2 => {
                        return item.sale_part_code != item2.sale_part_code  &&  item.sale_part_version!= item2.sale_part_version &&  item.customer_code!= item2.customer_code 
                       });
                });
                data = arr;
                for (let i = 0; i < data.length; i++) {
                    that.dataSet = [
                        ...that.dataSet,
                        {
                            sale_part_code: data[i].sale_part_code,
                            sale_part_version: data[i].sale_part_version,
                            after_flag: data[i].after_flag,
                            cust_version: data[i].cust_version,
                            customer_code: data[i].customer_code,
                            customer_part_code:data[i].customer_part_code,
                            valid_flag:data[i].valid_flag,
                            isfreeze:data[i].isfreeze,
                            status:'',
                            errmsg:''
                        }
                    ];
                }
            },
            handleSelectionChange({records}) {
                let that = this;
                for (let i = 0; i < records.length; i++) {
                    that.dataChecked.push(records[i].Exclusively_id);
                }
            },
            remove() {
                let that = this;
                let selectRecords = this.$refs.CloseSoTable.getCheckboxRecords();
                for(let i=selectRecords.length-1;i>=0;i--){
                    let line = this.$refs.CloseSoTable.getRowIndex(selectRecords[i]);
                    that.dataSet.splice(line, 1);
                }
            },
            handleChange(file, fileList) {
                let that = this;
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                that.fileList=[];
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    
                    let data = res.DataContent
                    for (let i = 0; i < data.length; i++) {
                        that.dataSet = [...that.dataSet, {
                            sale_part_code: data[i].sale_part_code,
                            sale_part_version: data[i].sale_part_version,
                            after_flag:data[i].after_flag,
                            cust_version: data[i].cust_version,
                            customer_code: data[i].customer_code,
                            customer_part_code:data[i].customer_part_code,
                            valid_flag:data[i].valid_flag,
                            isfreeze:data[i].isfreeze,
                            status:'',
                            errmsg:''
                        }]
                    }
                    
                }
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            update() {
                let that = this;
                if (that.editPlan == '0') {
                    that.$message.warning(that.$t('getapi[8625]'));//'请选择更新字段'
                    return
                }
                let arr=[];
                for (let i = 0; i < that.dataSet.length; i++) {
                    arr = [
                        ...arr,
                        {
                            status: that.dataSet[i].status,
                            errmsg: that.dataSet[i].errmsg,
                            sale_part_code: that.dataSet[i].sale_part_code,
                            sale_part_version: that.dataSet[i].sale_part_version,
                            cust_version: that.dataSet[i].cust_version,
                            customer_code: that.dataSet[i].customer_code,
                            customer_part_code: that.dataSet[i].customer_part_code,
                            valid_flag: that.dataSet[i].valid_flag,
                            isfreeze: that.dataSet[i].isfreeze,
                            after_flag:that.dataSet[i].after_flag == 'Y'?1:0,
                        }
                    ];
                }
                let parm = {
                    Lists: arr,
                    name: that.editPlan
                };
                that.$http.urlpost('/Sal/Price/BatchSalPriceFreeze', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    .c-search-table {
        width: 100%;
        height: calc(~'100% - 10px'); /*这里我用了计算属性*/
    }

    .beauty-Scroll {
        .el-scrollbar {
            height: 100%; /*此处一定要设置高度，不然内层的计算属性不生效*/
        }
        .el-scrollbar__wrap {
            width: calc(~'100% + 17px'); /*将垂直滚动条挤到可视区域之外*/
            height: calc(~'100% + 17px'); /*将水平滚动条挤到可视区域之外*/
        }
    }
    

    input {
        width: 100%;
        height: 35px;
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        padding-left: 2px;
        padding-right: 2px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
        }
    }

    .alignment-left {
        text-align: left;
    }

    .alignment-right {
        text-align: right;
    }

    .el-pagination {
        white-space: inherit;
    }
    
</style>
